import React , { Component }  from 'react';
import './App.css';
import Header from './components/header.js'; 
import Social from './components/social.js'; 
import About from './components/about.js'; 
import { useMediaQuery } from 'react-responsive'
import Technologies from './components/technologies';
import TechAnimation from './components/techAnimation';

export default class App extends Component{
  render(){
  return (
    <div>
        <DesktopOrMobile>
        </DesktopOrMobile>
    </div>
  )};
}

const DesktopOrMobile = () => {
  let isMobile = useMediaQuery({ maxWidth: 767 });
  return (
    <div className ={`container${isMobile ? "-mobile" : ""}`}>
      <Header mobileclass={`${isMobile ? "mobile" : ""}`}></Header>
      <svg className="pixelWave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220"><path fill="beige" fillOpacity="1" d="M0,288L0,224L38.9,224L38.9,96L77.8,96L77.8,64L116.8,64L116.8,96L155.7,96L155.7,256L194.6,256L194.6,128L233.5,128L233.5,160L272.4,160L272.4,32L311.4,32L311.4,96L350.3,96L350.3,256L389.2,256L389.2,160L428.1,160L428.1,224L467,224L467,256L505.9,256L505.9,192L544.9,192L544.9,96L583.8,96L583.8,160L622.7,160L622.7,64L661.6,64L661.6,64L700.5,64L700.5,160L739.5,160L739.5,0L778.4,0L778.4,288L817.3,288L817.3,32L856.2,32L856.2,288L895.1,288L895.1,128L934.1,128L934.1,0L973,0L973,160L1011.9,160L1011.9,0L1050.8,0L1050.8,192L1089.7,192L1089.7,96L1128.6,96L1128.6,64L1167.6,64L1167.6,224L1206.5,224L1206.5,256L1245.4,256L1245.4,160L1284.3,160L1284.3,96L1323.2,96L1323.2,64L1362.2,64L1362.2,224L1401.1,224L1401.1,128L1440,128L1440,320L1401.1,320L1401.1,320L1362.2,320L1362.2,320L1323.2,320L1323.2,320L1284.3,320L1284.3,320L1245.4,320L1245.4,320L1206.5,320L1206.5,320L1167.6,320L1167.6,320L1128.6,320L1128.6,320L1089.7,320L1089.7,320L1050.8,320L1050.8,320L1011.9,320L1011.9,320L973,320L973,320L934.1,320L934.1,320L895.1,320L895.1,320L856.2,320L856.2,320L817.3,320L817.3,320L778.4,320L778.4,320L739.5,320L739.5,320L700.5,320L700.5,320L661.6,320L661.6,320L622.7,320L622.7,320L583.8,320L583.8,320L544.9,320L544.9,320L505.9,320L505.9,320L467,320L467,320L428.1,320L428.1,320L389.2,320L389.2,320L350.3,320L350.3,320L311.4,320L311.4,320L272.4,320L272.4,320L233.5,320L233.5,320L194.6,320L194.6,320L155.7,320L155.7,320L116.8,320L116.8,320L77.8,320L77.8,320L38.9,320L38.9,320L0,320L0,320Z"></path></svg>
      <About isMobile={isMobile}></About>
      <Technologies></Technologies>
      <TechAnimation></TechAnimation>
      <Social></Social>
    </div>
  )
}